const FAQS_BTFDCA = [
  {
    id: "btfdca",
    question: "What's BTFDCA?",
    answer:
      "A service to buy crypto assets through <dollar> cost averaging (DCA). It buys cryptoassets for you, every day, over a given period of time. You just set and forget.",
  },
  {
    id: "dca",
    question: "What's Dollar Cost Averaging (DCA)?",
    answer:
      'It\'s an investment strategy where you periodically buy a target asset in constant amounts. Also known as "Recurring Buy" in some places.',
  },
  {
    id: "target-audience",
    question: "Who is this for?",
    answer:
      "For long-term investors that want to HODL. For lazy investors (like myself) who want to chill through the ride. For people who want to diversify their investment strategies.",
  },
  {
    id: "where",
    question: "What chains can I use?",
    answer: "Right now, Polygon. But expanding to other chains, SOON (tm).",
  },
  {
    id: "work",
    question: "How does BTFDCA work?",
    answer:
      "TLDR: You pick a token/asset pair, define the length, and an amount. Then you BTFDCA, which starts streaming your token to a pool (i.e. a smart contract). Periodically, the contract buys the asset, and then sends it to you. BTFDCA uses Superfluid as a base protocol for streaming money.",
  },
  {
    id: "get-assets",
    question: "How do I get my assets?",
    answer:
      "After each buy, the contract automatically distributes your share of the assets to your wallet. Note: you'll need to do a 1 time approval for this to happen. Until then, the assets will be waiting for you.",
  },
  {
    id: "funds",
    question: "What happens if my wallet runs out of funds?",
    answer:
      "Your stream stops, and the amount of tokens since the last distribution is automatically returned back to you.",
  },
];

const FAQS_SUPERFLUID = [
  {
    id: "money-streams",
    question: "What are money streams?",
    answer:
      "This is a protocol popularized by Superfluid Finance. It allows crypto to be sent, over time, between accounts, with negligible cost. This is done by wrapping the ERC20 token into what's called a Super Token.",
  },
  {
    id: "erc20-tokenx",
    question: "ERC20 vs Super Tokens (AKA TokenX)",
    answer:
      "ERC20 is the standard for tokens from Ethereum and EVM-like chains. Super Tokens are a protocol developed by Superfluid.finance, and they simply wrap ERC20s with some additional functionality (streaming).",
  },
  {
    id: "upgrade-downgrade",
    question: "Upgrading and Downgrading tokens",
    answer: "Upgrading converts ERC20 tokens into Super Tokens. Downgrading converts Super Tokens into ERC20 tokens.",
  },
  {
    id: "escrow",
    question: "What's this escrow thing?",
    answer:
      "When you BTFDCA, some of your funds are automatically put on hold (i.e. escrow). This is controlled by Superfluid protocol, and it is done to avoid spam attacks. These funds are not lost - they are used during the streaming (or returned to you if you decided to cancel the stream). The amount held in escrow is equal to 4 hours × flowrate.",
  },
  {
    id: "flowrate",
    question: "What's this flowrate thing?",
    answer: "It's the amount of Super Tokens per second that is being streamed from one account to another.",
  },
  {
    id: "subscriptions",
    question: "What are these subscriptions things and why do I need to approve them?",
    answer:
      "For the assets to be sent to your wallet, Superfluid requires you to approve their distribution. This is a one time action (per stream). Your assets are held by the protocol until you approve the subscription.",
  },
];

const FAQS_INVESTORS = [
  {
    id: "why",
    question: "Why should I use this?",
    answer:
      "That's for you to decide. I say: use BTFDCA to buy assets that matter, with low fees, and through a straight to the point UI. I also have several innovations coming up that I hope will appeal to you.",
  },
  {
    id: "cost",
    question: "How much does it cost?",
    answer:
      "BTFDCA takes 1 basis point (that's 0.01%) for each DCA swap (per pool). Note that this is configurable, and will be announced beforehand if it changes. Superfluid (the streaming protocol) currently takes no fees. Note: You'll have to pay transaction fees when starting a stream, approving a subscription, and upgrading/downgrading tokens.",
  },
  {
    id: "periodicity",
    question: "When is the buy+distribution order done?",
    answer:
      "BTFDCA uses Gelato keepers to trigger the buy order on a daily basis. But due to the way the smart contract works, other events can trigger a buy order. Note that it will only spend what you have streamed up to that instant.",
  },
  {
    id: "where-buy",
    question: "Where are the assets bought from?",
    answer:
      "Depends on the network and the pair. BTFDCA tries to use the most liquid exchanges for the target pairs. On Polygon, it will start with Uniswap.",
  },
  {
    id: "assets",
    question: "What assets can I buy, and what tokens can I spend?",
    answer:
      "The list is going to be very long, very quickly, but you'll be able to BTFDCA on Polygon with USDC as a source token, to buy BTC, ETH, MATIC, and many other assets. Please let me know if you're looking for something not available.",
  },
  {
    id: "rolling",
    question: "How does rolling length work?",
    answer:
      "When you select rolling length, the number of days is the minimum amount of days that we'll DCA for you. The DCA will continue if your wallet is funded with more than the amount that was indicated, and will stop otherwise.",
  },
];

const FAQS_SECURITY = [
  {
    id: "risks",
    question: "What are the risks when using BTFDCA?",
    answer:
      "The usual DeFi risks apply here. None of this is financial advice, so do your own research. There's a smart contract risk, there's unforseen hack risk, there's a rug pull risk, there's frontrunning risk, there's a risk the assets you buy go underwater, etc etc.",
  },
  {
    id: "rug",
    question: "Rug pull risk??? Are you gonna rug me?",
    answer: "I have no intentions of doing that. And at most, you would lose 1 day's worth of your streamed tokens.",
  },
  {
    id: "secure",
    question: "How secure is BTFDCA?",
    answer:
      "Hopefully, as secure as possible. But hope is not enough. There are automated tests, with code coverage greater than 0 (lol), and different set of eyes went through the code.",
  },
  {
    id: "audited",
    question: "Are the contracts audited?",
    answer: "Not yet. Those are expensive, but will do it once there's funding.",
  },
];

const FAQS_CONTACT = [
  {
    id: "who",
    question: "Who built this?",
    answer: "It is I, @omnifient.",
  },
  {
    id: "trust",
    question: "Why should I trust you?",
    answer:
      "Don't trust, verify. But for what it's worth, BTFDCA was a finalist in ETHGlobal's HackMoney 2022 (https://twitter.com/ETHGlobal/status/1529576980873617410), and Encode x Polygon Hackathon (https://twitter.com/encodeclub/status/1546919565212487682).",
  },
];

const FAQS_HELP = [
  {
    id: "how-help",
    question: "I'd love to help you, what can I do?",
    answer: "Reach out to @omnifient on discord/twitter/email, and we'll talk about it.",
  },
];

export { FAQS_BTFDCA, FAQS_SUPERFLUID, FAQS_INVESTORS, FAQS_SECURITY, FAQS_CONTACT, FAQS_HELP };
